// modules
import { createAction } from 'redux-actions'

// actions
export const setPatientActivityLog = createAction('SET_PATIENT_ACTIVITY_LOG')
export const setActivityLogPredefinedFilter = createAction(
  'SET_ACTIVITY_LOG_PREDEFINED_FILTER'
)

export const deletePatientActivityLog = createAction(
  'DELETE_PATIENT_ACTIVITY_LOG'
)
